module.exports = __webpack_public_path__ + "c626e73ae44f0aa36075603ae944fb2d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/groovy.png
// module id = 374
// module chunks = 1